/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/*==================================================================	
	# Add to cart code for collections/frontpage 	
==================================================================*/	

$(document).ready(function(){

  document.addEventListener('product:added', function(event) {
    var variant = event.detail.variant; // Get the variant that was added
    var quantity = event.detail.quantity; // Get the quantity that was added
  });

  $(document).on('click','.frontpage_add_to_cart',function(){
    var quantity = 1;
    var variant_id = $(this).attr('data-varid');
    var ajax_cart_data = {
      quantity: quantity,
      id: variant_id,
    }

    $.ajax({
      type: "POST",
      url: '/cart/add.js',
      dataType: "json",
      data: ajax_cart_data,

      error: function(data, textstatus) {
      },
      success: function(data, textstatus) {
        $.getJSON('/cart.js', function(cart) {
          var value = $(".Header__CartCount").html() || '0';
          $('.Header__CartCount').html(value.replace(/[0-9]+/,cart.item_count)).removeClass('hidden-count');
        });
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: variant_id,
            quantity: quantity
          }
        }));

      }
    }); 
  });


  /*==================================================================	
	# checking if gift card is already added in cart and making checkbox true 	
	==================================================================*/	


  var variant_id = $('#add-gift-wrap').data('variant-id');

  setTimeout(function () {

    $.ajax({
      type: "GET",
      url: '/cart.js',
      dataType: "json",
      error: function(data, textstatus){
      },
      success: function(data, textstatus){
        $.each(data.items, function(key,val){
          if(val.id == variant_id){
            $('#add-gift-wrap').prop("checked",true);
          }
        });
      }
    });
  }, 1500);

  /*==================================================================	
	# add ift card in cart 	
	==================================================================*/	

  $(document).on('click','#add-gift-wrap',function(){

    var variant_id = $(this).data('variant-id');
    if($(this).prop('checked') == true){

      var ajax_cart = {
        quantity: 1,
        id: variant_id,
      }

      $.ajax({
        type: "POST",
        url: '/cart/add.js',
        dataType: "json",
        data: ajax_cart,
        error: function(data, textstatus) {
        },
        success: function(data, textstatus) {
        }
      });
    }
    /*==================================================================	
	# remove gift card on checkbox uncheck 	
	==================================================================*/	

    else{

      var ajax_cart = {
        updates: {42257755144414: 0}  
      }

      $.ajax({
        type: "POST",
        url: '/cart/update.js',
        dataType: "json",

        data: ajax_cart,
        error: function(data, textstatus){
        },
        success: function(data, textstatus){
        }
      });
    }

  });

  $(window).on('load', function() {
    var pathname = window.location.pathname;
    if(pathname == "/collections/all"){
      $("#collection-filter-drawer").attr("aria-hidden", "false");
      $("#collection-filter-drawer").attr("tabindex", "-1");
      $(".PageOverlay").addClass("is-visible");
      $('html').addClass("no-scroll");
    }

    if($('.PageOverlay').hasClass('is-visible')){
      $('.is-visible').click(function(){
        $("#collection-filter-drawer").attr("aria-hidden", "true");
        $("#collection-filter-drawer").removeAttr("tabindex");
        $(".PageOverlay").removeClass("is-visible");
        $('html').removeClass("no-scroll");
      });
    }

  });

  $('.Drawer__Close').click(function(){
    $("#collection-filter-drawer").attr("aria-hidden", "true");
    $("#collection-filter-drawer").removeAttr("tabindex");
    $(".PageOverlay").removeClass("is-visible");
    $('html').removeClass("no-scroll");
  });



  /*==================================================================	
		Quiz Development Starts
	==================================================================*/	
  var collectionHandle = '';
  var getCollectionTitle = '';
  var getCollectionImage = '';
  var getGenderValue = '';
  let genderText = '';
  let replaceGenderText = '';
  let genderBornText = "";
  let replaceGenderBornText = '';
  let genderCategoryText = "";
  let replaceGenderCategoryText = '';
  let priceCategoryText = "";
  let replacePriceCategoryText = '';
  var selct_tag = [];
  var getPurchseValue = '';
  var selectedPrice = '';

  $(document).on('click','.shop-type', function(e){
    $('.shop-type').removeClass('quiz_option_selected');
    $(this).addClass('quiz_option_selected');
    collectionHandle = $(this).attr('data-handle');
    getGenderValue = $(this).attr('data-gender'); 
    getCollectionTitle = $(this).attr('data-title');


    //Get Gender Value
    $("#collectionValue").html(getCollectionTitle);
    getCollectionImage = $(this).find("#collection-img").attr('src');
    $('#get-collection-image').attr('src', getCollectionImage);
    $('#get-selected-image').attr('src', getCollectionImage);

    priceCategoryText = document.getElementById("selcted__collection-title").innerHTML;
    replacePriceCategoryText = priceCategoryText.replace(/{gen}/g, getCollectionTitle);
    document.getElementById("selcted__collection-title").innerHTML = replacePriceCategoryText;

    _loadJsonData(parseInt(100), collectionHandle);
    $(".button-imagimake-quizpage" ).removeAttr('disabled');
  });


  $(document).on('click','.button-imagimake-quizpage', function(e){
    genderText = document.getElementById("genderValue").innerHTML;
    if(getGenderValue === 'she'){
      replaceGenderText = genderText.replace(/{gen}/g, "her");
      replaceGenderText = replaceGenderText.replace(/his/g, "her");
    } else {
      replaceGenderText = genderText.replace(/{gen}/g, "his");
      replaceGenderText = replaceGenderText.replace(/her/g, "his");
    }
    document.getElementById("genderValue").innerHTML = replaceGenderText;
  });

  $(document).on('click','.button-imagimake-quizform', function(e){
    //Change Gender D.O.B
    genderBornText = document.getElementById("genderBorn").innerHTML;
    if(getGenderValue === 'she'){
      replaceGenderBornText = genderBornText.replace(/{gen}/g, "she");
      replaceGenderBornText = replaceGenderBornText.replace(/\bhe\b/g, "she");
    } else {
      replaceGenderBornText = genderBornText.replace(/{gen}/g, "he");
      replaceGenderBornText = replaceGenderBornText.replace(/she/g, "he");
    }
    document.getElementById("genderBorn").innerHTML = replaceGenderBornText;
  });	

  $(document).on('click','.button-imagimake-quiz', function(e){
    //Change Gender Category
    genderCategoryText = document.getElementById("genderCategory").innerHTML;
    if(getGenderValue === 'she'){
      replaceGenderCategoryText = genderCategoryText.replace(/{gen}/g, "she");
      replaceGenderCategoryText = replaceGenderCategoryText.replace(/\bhe\b/g, "she");
    } else {
      replaceGenderCategoryText = genderCategoryText.replace(/{gen}/g, "he");
      replaceGenderCategoryText = replaceGenderCategoryText.replace(/she/g, "he");
    }
    document.getElementById("genderCategory").innerHTML = replaceGenderCategoryText;
  });	

  // For checkbox event 
  $(document).on('click','.block_settings_image .pick-category', function(e){ 
    //max 3 logic
    $(this).toggleClass('category_selected');
    if($('[data-question="pick_categories"]').length > 0 && $('[data-question="pick_categories"] .category_selected').length >3 ){
      $(this).removeClass('category_selected');
      return;
    }
    else {
      if($('[data-question="pick_categories"] .category_selected').length <= 0) {
        $(".button-imagimake-quiz-image" ).prop('disabled', true);
      }
      else {
        $(".button-imagimake-quiz-image" ).removeAttr('disabled');
      }
    }
  });

  $(document).on('change','.radio-age', function(e){  
    $(".button-imagimake-quiz" ).removeAttr('disabled');
  });

  $(document).on('change','.radio_buttons', function(e){  
    $(".button-imagimake-quizradio" ).removeAttr('disabled');
  });

  $(document).on('change','.radio-price', function(e){  
    $(".button-imagimake-radiobtn-quiz" ).removeAttr('disabled');
  });

  let userNameInput = document.getElementById("user_name");
  userNameInput.addEventListener("input", function(e) {
    if(userNameInput.value.length == 0) {
      $(".button-imagimake-quizform" ).prop('disabled', true);
    } else {
      $(".button-imagimake-quizform" ).removeAttr('disabled');
    }
  });

  //store username and show on another page
  $(document).on('click','.quiz-form .next-btn', function(e){
    var userTypedValue = $('#user_name').val();
    $("#get-username").html(userTypedValue);
  });

  //show all the products on quiz submit
  $(document).on('click','.quiz-submit', function(e){
    _getProducts();
    submitQuizData();
  });

  // Code for section next and prev button click navigation
  $('.navigate-button').click(function () {
    let ide = $(this).attr('data-target');
    $('.section').hide();
    $('#' + ide).show();
    $("html, body").animate({ scrollTop: 0 }, 600); 
  });  

  // Date Picker
  $(function () {
    $("#datepicker").datepicker({ 
      autoclose: true, 
      todayHighlight: true,
    }).datepicker('update', new Date());
  });
  
});

let allProducts = [];
const productPerAjax = 100;

function _loadJsonData(totalProducts, collectionHandle) {
  let productPagination = Math.ceil(totalProducts / productPerAjax),
      o = "";
  let url = "/collections/"+ collectionHandle + "?" + o + "view=json&page=",
      arr = [];
  for (var i = 1; i <= productPagination; i++) {
    let productLength = i;
    arr.push(
      $.get(url + productLength, function (a) {
        let e = JSON.parse(a);
        for (var o = 0; o < e.length; o++) allProducts[(productLength - 1) * productPerAjax + o] = e[o];
      })
    );
  }
  $.when.apply($, arr).done(function () {
    (allProducts = allProducts.filter(function (t, a) {
      return t || null;
    }))
  });
}

function loadRemotely() { 
  _loadJsonData(parseInt(100));
}
loadRemotely();

function _getProducts () {
  let filteredProducts = _filterProducts(allProducts);
  if(filteredProducts.length > 0) {
	renderProduct(filteredProducts)
  }
}

function renderProduct(_getProducts){
  var productHtml = '';
  productHtml += '<div class="quiz-result final-pdp-section">';
  for(var i=0; i<_getProducts.length; i++) {
    var product = _getProducts[i];
    var selectedVariant = {};      
    var availableVariants = product.variants.filter(function(v) {
      return v.available;
    });

    if(availableVariants.length) {
      selectedVariant = availableVariants[0];
    }
    
    if(Object.keys(selectedVariant).length) {
      productHtml += '<div class="product-grid">'
      productHtml += '<div class="ProductListWrapper">'
      productHtml += '<a href="/products/'+ product.handle+'" target="_blank" class="ProductItem__ImageWrapper">';
      productHtml += '<img class="grid-view-item__image" src="'+ product.featured_image +'">';
      productHtml += '</a>'; 
      productHtml += '<div class="ProductItem__Info ProductItem__Info--center">'
      productHtml += '<h2 class="ProductItem__Title Heading">';
      productHtml += '<a href="/products/'+ product.handle+'" target="_blank">'+ product.title +'</a>';
      productHtml += '</h2>';
      productHtml += '<div class="ProductItem__PriceList  Heading">';
      var price = product.price / 100;
      var comparePrice = product.compare_at_price / 100;
      productHtml += '<span class="ProductItem__Price Price Text--subdued"><span class="symbol"> ₹ </span> <span class="price_text"> '+ price +' </span></span>';
      
      if(product.compare_at_price){
          productHtml += '<span class="compare_price-item">₹ '+ comparePrice +'</span>';
      }
      
      productHtml += '</div>'
      productHtml += '</div>'
      productHtml += '<div class="ProductItem__Button">'
      productHtml += '<button type="submit" name="add" aria-label="Add to cart" class="frontpage_add_to_cart add_to_cart_6640611098679" id="ad_to_cart" aria-haspopup="dialog" data-add-to-cart="'+ selectedVariant.id +'" data-varid="'+ selectedVariant.id +'">Add to Cart</button>';
      productHtml += '</div>'
      productHtml += '</div>'
      productHtml += '</div>'
    }
  }
  productHtml += '</div>';
  $('.final-products').append(productHtml);
}

function submitQuizData(){
  let collectionHandle = $('.shop-type').attr('data-handle');
  let userTypedValue = $('#user_name').val();
  let selectedDate = $('.date-picker').val();
  let getSelectedAge = $('input[name="radio-age"]:checked').attr('data-age');
  let select_tag = [];
  $('[data-question="pick_categories"] .category_selected').each(function(i, obj) {
    select_tag.push($(obj).attr('data-tag'))
  });
  let getStringTags = select_tag.toString();
  let purchasePurpose = $('input[name="radio-purchase"]:checked').val().toLowerCase();
  let priceSelect = $('input[name="price"]:checked').val();
  
  let data_to_send = {
    'Question 1': collectionHandle,
    'Question 2': userTypedValue,
    'Question 3': selectedDate,
    'Question 4': getSelectedAge,
    'Question 5': getStringTags,
    'Question 6': purchasePurpose,
    'Question 7': priceSelect
  };

  $.ajax({
    url: 'https://script.google.com/macros/s/AKfycbwgTaMRoil-FH1teUHoY4gdpPIrAzceBFWJnVFk_5J8kpSgnHJn9ITjF5YEGFH4BiqP/exec',
    method: "GET",
    dataType: "json",
    data: data_to_send,
  }).done(function(data){
  })
}

let _filterProducts = function(data) {
  let select_tag = [];
  $('[data-question="pick_categories"] .category_selected').each(function(i, obj) {
    select_tag.push($(obj).attr('data-tag'));
  });
  
  
  let purchasePurpose = $('input[name="radio-purchase"]:checked').attr('data-purchase');
  
  let priceSelect = $('input[name="price"]:checked').val();
  var priceRange = String(priceSelect).split("-");
  
  let getSelectedAge = $('input[name="radio-age"]:checked').attr('data-age');
  
  let dataOutput = data.filter(function(product){
  var priceOfProduct = product.price / 100; 
    //filtering all the products
    if(product.available && product.tags.some(r=> select_tag.includes(r)) && product.tags.some(r=> purchasePurpose.includes(r)) && product.tags.some(r=> getSelectedAge.includes(r)) && priceOfProduct >= priceRange[0] && priceOfProduct <= priceRange[1]){
      return true;
    }
  });

  return dataOutput;
}

/*==================================================================	
		Quiz Development Ends
	==================================================================*/

// Search Bar Dynamic placeholder text changing code //

document.addEventListener("DOMContentLoaded", function () {
  let index = 0;
  let searchInput = getSearchInput();
  let intervalId;

  function getSearchInput() {
      return window.matchMedia("(min-width: 769px)").matches
          ? document.getElementById("searchInput")
          : document.getElementById("customSearchInput");
  }

  function changePlaceholder() {
      if (!searchInput || !placeHolderTexts.length || searchInput.value.trim() !== "") return;

      // Fade out effect
      searchInput.style.opacity = 0;

      setTimeout(() => {
          searchInput.placeholder = placeHolderTexts[index]; // Change text
          searchInput.style.opacity = 1; // Fade in
          index = (index + 1) % placeHolderTexts.length;
      }, 500);
  }

  function applyPlaceholderEffect() {
      searchInput = getSearchInput();
      if (!searchInput) return;

      // Clear previous interval if exists
      clearInterval(intervalId);

      // Start the interval for desktop and mobile
      intervalId = setInterval(changePlaceholder, 3000);

      // Pause effect when user types
      searchInput.addEventListener("input", () => {
          if (searchInput.value.trim() !== "") {
              clearInterval(intervalId);
          } else {
              intervalId = setInterval(changePlaceholder, 3000);
          }
      });
  }

  // Initial call
  applyPlaceholderEffect();

  window.matchMedia("(min-width: 769px)").addEventListener("change", () => {
    // Clean up existing interval and listeners
    if (intervalId) {
      clearInterval(intervalId);
      if (searchInput) {
          searchInput.removeEventListener("input", handleInput);
        }
      }
      applyPlaceholderEffect();
    });
});